var map = {
	"./maq1.jpg": 310,
	"./maq2.jpg": 6161,
	"./maq3.jpg": 4356,
	"./maq4.jpg": 8991,
	"./maq5.jpeg": 1727,
	"./maq6.jpg": 157,
	"./maq7.jpg": 5264,
	"./maq8.jpg": 9547,
	"./maq9.jpg": 1502,
	"./maqq10.jpg": 53,
	"./maqq11.jpg": 7688,
	"./maqq12.jpg": 8263,
	"./maqq13.jpg": 7450,
	"./maqq14.jpg": 9289,
	"./maqq15.JPG": 3041,
	"./maqq16.jpg": 363,
	"./maqq17.jpg": 5582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8369;